import React, { ReactNode, ReactElement, ComponentType } from 'react';
import { useDeviceType, DeviceType } from '@cars4ever/public-ui';

import MobileSkeleton from './MobileSkeleton';
import TabletSkeleton from './TabletSkeleton';
import DesktopSkeleton from './DesktopSkeleton';
import styles from './styles.module.scss';

export interface IModelChooserSkeletonProviderProps {
  children?: ReactNode;
  showSkeleton: boolean;
}

const configSkeleton: Record<DeviceType, ComponentType> = {
  [DeviceType.Mobile]: MobileSkeleton,
  [DeviceType.Tablet]: TabletSkeleton,
  [DeviceType.Desktop]: DesktopSkeleton,
};

const ModelChooserSkeletonProvider = ({ showSkeleton, children }: IModelChooserSkeletonProviderProps): ReactElement => {
  const { deviceType } = useDeviceType();

  const Skeleton = configSkeleton[deviceType];

  return (
    <>
      {showSkeleton ? (
        <div className={styles.skeletonWrapper}>
          <Skeleton />
        </div>
      )
        : children
      }
    </>
  );
};

export default ModelChooserSkeletonProvider;

